import { render, staticRenderFns } from "./DataChartGBS.vue?vue&type=template&id=171586b0&"
import script from "./DataChartGBS.vue?vue&type=script&lang=js&"
export * from "./DataChartGBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports